/**
 * 
 * Service Dama JS
 * 
 * 
 */

export class dama {
  welcome(){
    return 'welcome to DAMA'
  }
  click(name: string = null, configuration: any) {
    const element = document.querySelectorAll('[dm-click=' + name + ']')[0]
    element && element.addEventListener("click", configuration, false)
    return 'render';
  }
  hide(ids: any = []) {
    ids.map((id: any) => {
      const element = document.getElementById(id);
      if (element) element.style.display = "none";
    });
    return "render";
  }
  show(id: string = null) {
    const element = document.getElementById(id);
    if (element) element.style.display = "block";
    return "render";
  }
  hideOne(id: string = null) {
    const element = document.getElementById(id);
    if (element) element.style.display = "none";
    return "render";
  }
  hideShow(idHide: string = null, idShow: string = null) {
    let element = document.getElementById(idHide);
    if (element) element.setAttribute("style", "display:none !important");
    element = document.getElementById(idShow);
    if (element) element.setAttribute("style", "display:block !important");
    return "render";
  }

  print(name: string, text: string) {
    const element = document.querySelectorAll("[dm-model=" + name + "]")[0];
    if (typeof element != "undefined" && element != null)
      element.textContent = text;
    return;
  }

  printOneTagHtml(name: string, html: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const parsedHtmlElement = doc.body.firstElementChild as HTMLElement;

    const elements = document.querySelectorAll("[dm-model=" + name + "]");
    elements.forEach((element) => (element.appendChild(parsedHtmlElement)));
    return;
  }

  renderPage(data: any) {
    const keys = Object.keys(data);
    keys.map((key) => this.printOneTagHtml(key, data[key]));
  }
}